import { mirrorX, setDefaultStyleWithStroke } from "apparatus/draw";
import { R, Segments } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
export class Dropper {
    render(appearance) {
        let height = appearance.size;
        let width = 8 + height / 15;
        let handle = this.handle();
        setDefaultStyleWithStroke("thin", handle);
        handle.fillColor = "#555555";
        handle.closePath();
        let body = this.body(width, height);
        // Center the pipette body.
        body.position.x += handle.bounds.center.x - body.bounds.center.x;
        let liquidMask = body.clone();
        setDefaultStyleWithStroke("thin", body);
        var graphic = new Group([body, handle]);
        var hitShape = Shape.Rectangle(R(0, -handle.bounds.height, handle.bounds.width, graphic.bounds.height));
        return {
            graphic: graphic,
            hitShape: hitShape,
            liquidMask: liquidMask,
            snapping: graphic.placeable(),
        };
    }
    body(width, height) {
        let mouthSize = 5;
        let path = new Path(Segments([[width / 2 - mouthSize / 2, height + 12]], [[width / 2 - mouthSize / 2, height + 7]], [[0, height], [0, 7]], [[0, 0]]));
        mirrorX(path, width / 2);
        return path;
    }
    handle() {
        let height = 30;
        let width = 20;
        let path = new Path(Segments([[0, 0]], [[0, -5], undefined, [10, -5]], [[width / 2, -height], [-12, 0]]));
        mirrorX(path, width / 2);
        return path;
    }
}
Dropper.properties = {
    label: "Dropper Pipette",
    canContainLiquids: true,
    defaultAppearance: {
        size: 60
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 30, max: 80
        }
    ],
};
